import { useRuntimeConfig } from "#imports";

// eslint-disable-next-line import/no-mutable-exports
export let GATEWAY_PREFIX_COMMON!: string;
export let GATEWAY_PREFIX_FORUM!: string;

// 通过 nuxt 插件初始化这些数据
export function initRuntimeConfig() {
  const config = useRuntimeConfig();
  GATEWAY_PREFIX_COMMON = config.public.GATEWAY_PREFIX_COMMON;
  GATEWAY_PREFIX_FORUM = config.public.GATEWAY_PREFIX_FORUM;
}
